import styled from 'styled-components'

export const Empty = styled.div`
	padding: 20px;
	text-align: center;
`
